"use client";

import { poppins_body_md_medium } from "@frontend/design-system";
import styled from "styled-components";

export const ActiveFlag = styled.div`
  height: 2rem;
  color: var(--Color-Common-Text-Success, #0198e9);
  ${poppins_body_md_medium}
  padding: 0 0.6rem;
  border-radius: var(--Border-Radius-4, 0.4rem);
  background: var(--Color-Common-Bg-Success-Subtle, #e6f6ff);

  &.status-active {
    color: var(--Color-Common-Text-Success, #0198e9);
    background: var(--Color-Common-Bg-Success-Subtle, #e6f6ff);
  }
  &.status-inactive {
  }
`;
